<template>
  <div class="deviceClauseNew section">
    <div class="section-header">
      <!-- <div></div> -->
      <!-- 增加今日的快捷选择 -->
      <!-- <el-date-picker
        v-model="selectedDate"
        :editable="false"
        :clearable="false"
        popper-class="select-date"
        :picker-options="pickerDayOptions"
      >
      </el-date-picker> -->

      <div class="datePreNext">
        <span class="date-icon"></span>
        <!-- 上一天 -->
        <span class="date-btn date-pre" @click="toPreDay"></span>
        <!-- 日期选择器 -->
        <!-- v-show="currentCategoryVal.datepickerType == 'date'" -->
        <!-- type="date" class="datepicker" align="center" -->
        <el-date-picker v-model="selectedDate" :editable="false" :clearable="false" popper-class="select-date"
          :picker-options="pickerDayOptions" ref="dateDay"></el-date-picker>
        <!-- 下一天 -->
        <span class="date-btn date-next" @click="toNextDay"></span>
      </div>

      <div class="exportClass">
        <!-- <download-excel
          v-show="currentData"
          class = "export-excel"
          :data = "json_data"
          :name = "filename">
          <button class="button-export">{{$t('report.Export_report')}}</button>
        </download-excel> -->

        <!-- 【搜索】 -->
        <!-- @click="queryData(true)" -->
        <!-- v-model.trim="search.search" -->
        <!-- @keyup.enter.native="getDeviceList(true)" -->
        <!-- :placeholder="this.$t('device.Sn_deviceName')" -->
        <!-- <el-button class="button button-solid" @click="showSearch = true;">
          <i class="el-icon-search"></i>
        </el-button>
        <div class="search-alert" v-show="showSearch">
          <el-input
            v-model="inputText"
            placeholder=""
            clearable
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <span class="search-hide" @click="showSearch = false;">取消</span>
        </div> -->

        <!-- 【字段控制】 -->
        <!-- <el-dropdown trigger="click">
          <span class="dropdown-trigger">
            <i class="iconfont icon-tiaoshi"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="clause-dropdown">
            <div class="topLine">
            <span style="display:inline-block;padding:5px 10px;font-size:14px;">显示字段</span>
            <span ></span>
            </div>
            <div class="allFiledNameClass" >
              <el-dropdown-item v-for="(item,index) in allFieldNameBox" :key="index">
                <el-checkbox v-model="item.flag" @change="setFields(item)">{{item.name}}</el-checkbox>
              </el-dropdown-item>
            </div>
          </el-dropdown-menu>
        </el-dropdown> -->
        <!-- 刷新 -->
        <div v-show="currentData" class="FieldControl" @click="queryData()">
          <div class="shuaxin center" :title="$t('device.refresh')"></div>
        </div>
        <!-- 字段控制 -->
        <div v-show="currentData" class="FieldControl" @click="fieldSwiat()">
          <div class="ziduan center" :title="$t('device.field')"></div>
          <!-- <span class="dropdown-trigger">
            <i class="iconfont icon-tiaoshi" ></i>
          </span> -->
        </div>

        <!-- 采集频率加速 -->
        <!-- <el-button type="button" :class="{ 'collectFastButtonElse': deviceDetailFrequencyUP&&currentData}"
           class=" collectFast"  :disabled="collectFastButton" @click="goCollectionUp()">
          <el-tooltip :content="deviceDetailFrequencyUP&&currentData?$t('collectionFrequencyUP.collect_fast1ing'):$t('collectionFrequencyUP.collect_fast1')" placement="top">
            <span class="collectFast-text">
            {{ collectFastText }}
            </span>
          </el-tooltip>
          <i class="iconfont icon-caiji"></i>
         </el-button> -->
        <el-button type="button"
           v-if="rechargeFlagObj&&rechargeFlagObj.accelerateEnabled"
           :class="{ 'collectFastButtonElse': collectFastBoolean}"
           class=" collectFast"  :disabled="collectFastButton" @click="goCollectionUp()">
          <el-tooltip :content="collectFastBoolean ? $t('collectionFrequencyUP.collect_fast1ing') : $t('collectionFrequencyUP.collect_fast1')" placement="top">
            <span class="collectFast-text">
              {{collectFastBoolean ? $t('collectionFrequencyUP.collect_fast1ing') : $t('collectionFrequencyUP.collect_fast1')}}
            </span>
          </el-tooltip>
          <i class="iconfont icon-caiji"></i>
         </el-button>
        <!-- 导出 -->
        <button type="button" @click="exportDeviceDetail()" class="button-export">
          {{ $t('report.Export_report') }}
          <!-- <i class="iconfont icon-export"></i> -->
          <i class="ico-download"></i>
        </button>
      </div>
    </div>
    <div class="section-content">
      <!-- @header-dragend="cellDragendWidth" -->
      <el-table height="100%" ref="tableRef" :data="tableData" stripe border :row-style="{ height: 0 }" :cell-style="{ padding: 0 }"
        :header-cell-style="{ background: '#3F515A', color: '#ffffff' }" v-loading="isLoading"
        element-loading-spinner="el-icon-loading" :empty-text="$t('account.nodata')" class="tablemain tableloding"
        @cell-mouse-enter="cellMouseEnterFun">
        <!-- :empty-text="$t('message.nodata')" -->
        <!-- :width="calcWidth(item)" -->
        <el-table-column :label="item" v-for="(item, index) in tableDataFields" :show-overflow-tooltip="true"
          width="180px" :prop="item" :key="index" :fixed="index == 0" :column-key="index + ''">
          <template slot="header" slot-scope="scope">
            <div :title="scope.column.label" :class="{ 'lightCol': curColIndex == index + '' }">{{ scope.column.label }}
            </div>
          </template>
          <template slot-scope="scope">
            <div :title="scope.column.label">{{ getSlotData(scope,item) }}
            </div>
          </template>
        </el-table-column>
        <!-- 无数据 -->
        <!-- <div v-show="emptyText" slot="empty">
          <img src="@/assets/img/empty_text.png"/>
          <div style="line-height: 32px">{{$t('account.nodata')}}</div>
        </div> -->
      </el-table>
    </div>
    <div class="tablebottom">
      <!-- 批量占位 -->
      <span class="" style="margin-left:16px;"></span>
      <el-pagination class="pagination" background @size-change="queryData(true)" @current-change="() => queryData()"
        :current-page.sync="pagination.currentPage" :page-sizes="[10, 15, 20, 30]" :page-size.sync="pagination.pagesize"
        layout="slot, sizes, total, pager, prev, next, jumper" :total="pagination.total" popper-class='select-page'>
        <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
      </el-pagination>
      <!-- 占个坑位，不然分页会掉出来屏幕之下 -->
      <!-- <div v-else class="pagination"></div> -->
    </div>
    <!-- 字段控制弹窗 -->
    <device-dialog :title="$t('device.field')" :width="'522px'" :height="'420px'" :class="{
      showDialog: controlDeviceVisible1,
      hideDialog: !controlDeviceVisible1,
    }" :visible.sync="controlDeviceVisible1">
      <div v-show="!vendorFlag" class="control tableloding" slot="content">
        <!-- <el-checkbox-group v-model="tableDataFields1" @change="handleCheck"> -->
          <!-- <el-checkbox v-model="item.flag"  v-for="item in allFieldNameBox" :key="item.name" :label="item.name" @change="setFields(item)">{{item.name}}</el-checkbox> -->
          <el-checkbox v-model="item.flag" v-for="(item,index) in allFieldNameBox" :key="index" :label="item.name">
            <el-tooltip :content="item.name" placement="top">
              <span class="name">{{ item.name }}</span>
            </el-tooltip>
          </el-checkbox>
        <!-- </el-checkbox-group> -->
      </div>
      <div v-show="vendorFlag" class="control tableloding" slot="content">
        <el-collapse v-model="activeNames" @change="handleChange">
          <div v-for="(item,index) in allFieldNameBoxGroup" :key=index>
            <el-collapse-item v-if="item.data.length>0"  :title="item.title" :name="index">
  
              <div style="border: 1px solid #17C28580;margin-bottom: 15px;padding: 10px;border-radius: 8px;">
                <div style="display: flex;justify-content: space-between;align-items: center;color: #a3c7d7;">
                  <!-- <div class="tableTitle">{{ $t(item.title) }}</div> -->
                  <!-- <div>全选</div> -->
                  <el-checkbox v-if="item.data.length>1" :indeterminate="item.indeterminate" v-model="item.checkAll" @change="handleCheckAllChange(index,item)">{{ $t('createPlant.select_all') }}</el-checkbox>
                </div>
                <!-- <div style="border-bottom: 1px solid #17C28580;height: 20px;"></div> -->
                <el-checkbox v-model="item1.flag"  v-for="(item1,index1) in item.data" :key="index1" :label="item1.name"  @change="handleSubItemChange(index, item)">
                  <el-tooltip :content="item1.name" placement="top">
                    <span class="name">{{ item1.name }}</span>
                  </el-tooltip>
                </el-checkbox>
              </div>
            </el-collapse-item>
          </div>
        </el-collapse>
        <!-- <div v-for="(item,index) in allFieldNameBoxGroup" :key="index">
        </div> -->
      </div>

      <div slot="footer" class="footBotton">
        <button class="button-hollow button1" @click="handleCheckAll2">{{ $t('basic.Select_all') }}</button>
        <button class="button-solid button" @click="submitSave">{{ $t('basic.Save') }}</button>
      </div>
    </device-dialog>
    <!-- 数据明细导出报表 -->
    <export-device-dialog :params.sync="exportDeviceParams"></export-device-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import encryption from "@/assets/js/encryption";
import request from "@/assets/js/request";
import config from "@/assets/js/config";
import { i18n } from '@/i18n';
import cookie from '@/assets/js/cookie';
import deviceDialog from "@/components/dialognew";
import exportDeviceDialog from "@/components/dialognew/exportDeviceData";
import { get } from 'lodash';
export default {
  components: {
    deviceDialog,
    exportDeviceDialog,
  },
  data () {
    return {
      // 采集充值按钮显隐判断标志
      rechargeFlagObj: null,
      // collectorForDIS接口返回的datFetch值
      datFetch: null,
      // deviceDetailFrequencyUP: false, // 采集频率加速按钮显示与否
      needDoLayout: true,
      vendorFlag: false,
      isIndeterminate: true,
      checkedCities: [],
      checkAll: false,
      allFieldNameBoxGroup: [
        { key: 'pv', title: i18n.t('createPlant.pv'), data: [] ,checkAll:false,indeterminate:true },
        { key: 'gd', title: i18n.t('createPlant.gd'), data: [] ,checkAll:false,indeterminate:true },
        { key: 'bt', title: i18n.t('createPlant.bt'), data: [] ,checkAll:false,indeterminate:true },
        { key: 'bc', title: i18n.t('createPlant.bc'), data: [] ,checkAll:false,indeterminate:true },
        { key: 'sy', title: i18n.t('createPlant.sy'), data: [] ,checkAll:false,indeterminate:true },
        { key: 'eg', title: i18n.t('createPlant.eg'), data: [] ,checkAll:false,indeterminate:true },
        { key: 'hl', title: i18n.t('createPlant.hl'), data: [] ,checkAll:false,indeterminate:true },
        { key: 'bse', title: i18n.t('createPlant.basic_settings'), data: [] ,checkAll:false,indeterminate:true },
        { key: 'std', title: i18n.t('createPlant.Standard_setting'), data: [] ,checkAll:false,indeterminate:true },
        { key: 'svs', title: i18n.t('createPlant.System_settings'), data: [] ,checkAll:false,indeterminate:true },
        { key: 'pvs', title: i18n.t('createPlant.Solar_settings'), data: [] ,checkAll:false,indeterminate:true },
        { key: 'grd', title: i18n.t('createPlant.Grid_settings'), data: [] ,checkAll:false,indeterminate:true },
        { key: 'bat', title: i18n.t('createPlant.Battery_settings'), data: [] ,checkAll:false,indeterminate:true },
        { key: 'bat1', title: i18n.t('createPlant.Battery_settings1'), data: [] ,checkAll:false,indeterminate:true },
        { key: 'bat2', title: i18n.t('createPlant.Battery_settings2'), data: [] ,checkAll:false,indeterminate:true },
        // { key: 'syo', title: 'createPlant.Work_settings2', data: [] },
        // { key: 'bco', title: 'createPlant.Machine_settings2', data: [] },
        // { key: 'res', title: 'createPlant.Clear_settings2', data: [] },
        { key: 'cts', title: i18n.t('createPlant.Control_settings'), data: [] ,checkAll:false,indeterminate:true },
        { key: 'los', title: i18n.t('createPlant.Load_setting'), data: [] ,checkAll:false,indeterminate:true },
        { key: 'bas', title: i18n.t('createPlant.Basic_setting'), data: [] ,checkAll:false,indeterminate:true },
        { key: 'adv', title: i18n.t('createPlant.Advanced_setting'), data: [] ,checkAll:false,indeterminate:true },
        { key: 'else', title: i18n.t('createPlant.other_settings'), data: [] ,checkAll:false,indeterminate:true },
      ],
      // 采集充值按钮是否能点击
      collectFastButton:false,
      exportDeviceParams:null,
      checkAll: false,//是否全选
      checked: false,
      isColor: "@primaryTextColor",
      controlDeviceVisible1: false,//弹窗开关
      emptyText: false,
      currentData: false,
      allFieldNameBox: [],//存放所有字段的盒子
      allFieldNameBox1: [],
      // filename:'',//导出文件名称
      // json_data:[],
      selectedDate: new Date(), // 所选时间
      isLoading: false, // 正在加载数据
      tableDataFields: [], // 表格列标题
      webHeads: [], // 表头(导出报表使用，display对应列显隐)
      // tableDataFields1: [], // 表格列标题
      tableData: [], // 表格数据
      pagination: {
        currentPage: 1,
        total: 0,
        pagesize: 15
      }, // 分页数据
      inputText: '', // 搜索内容
      showSearch: false, // 搜索弹出
      // 增加今日的快捷选择
      // i18n.t('device.cur_year')、cur_month、cur_day
      pickerDayOptions: {
        shortcuts: [{
          // text: `今天：
          //   ${String(new Date().getFullYear())}${i18n.t('device.year')}
          //   ${String(new Date().getMonth())}${i18n.t('device.month')}
          //   ${String(new Date().getDate())}${i18n.t('device.day')}
          // `,
          text: i18n.t('device.cur_today') + "：" +
            String(new Date().getFullYear()) + '/' +
            String(new Date().getMonth() + 1) + '/' +
            String(new Date().getDate())
          ,
          onClick (picker) {
            picker.$emit('pick', new Date());
          }
        }],
        disabledDate(time) {
          return time.getTime() > Date.now(); // 设置选择今天以及今天之前的日期
        },
      },
      // =================
      curColIndex: '',
      activeNames: '',
      // =================
      // arr:[]
    }
  },
  computed: {
    ...mapGetters({
      deviceInfo: 'getDeviceInfo'
    }),
    // collectFastText() {
    //   return this.deviceDetailFrequencyUP && this.currentData
    //     ? this.$t('collectionFrequencyUP.collect_fast1ing')
    //     : this.$t('collectionFrequencyUP.collect_fast1');
    // }
    collectFastBoolean() {
      return this.datFetch !== null && this.datFetch < 5 && this.currentData
    },
  },
  watch: {
    deviceInfo: {
      handler () {
        this.queryData()
        this.getQueryCollectorinfoEs()
        // this.allFieldNameBox()
        // 判断采集充值按钮显隐
       this.collectFastButtonVisible()
       this.goCollectionUp(true)
      },
      deep: true
    },
    allFieldNameBoxGroup: {
      handler (newVal) {
        this.allFieldNameBoxGroup.forEach((item, index) => {
          if (item.data.length > 0) {
            const allChecked = item.data.every(i => i.flag)
            const someChecked = item.data.some(i => i.flag)
            
            // ✅ 只更新状态，不覆盖用户操作
            item.checkAll = allChecked
            item.indeterminate = someChecked && !allChecked
          }
        })
      },
      deep: true
    },
    selectedDate () {
      this.queryData()
    }
  },
  created () {
    this.queryData()
    // this.getAllFieldName()
    this.loopQuery()
    this.getQueryCollectorinfoEs()
    // 判断采集充值按钮显隐
    this.collectFastButtonVisible()
    // 初始获取collectorForDIS数据
    this.goCollectionUp(true)
  },
  beforeDestroy () {
    clearInterval(this.timerEnergy);
  },
  methods: {
    // 判断采集充值按钮显隐
    collectFastButtonVisible() {
      this.$request.getDEVMicroservices("/ros/api/recharge/tariff/queryDisRechargeFlag", {pn: this.deviceInfo.pn}).then(res => {
        if (res.code === 0) {
          this.rechargeFlagObj =  res.data
          // this.rechargeFlagObj =  {accelerateEnabled: true, energyFlowEnabled: true}
        }
      });
    },
    handleChange(val) {
        console.log(val);
      },
    // 查询设备厂家编码
    getQueryCollectorinfoEs () {
      let params = {
        action: 'queryCollectorinfoEs',
        pn: this.deviceInfo.pn,
      }
      this.$request.get("queryCollectorinfoEs", params).then(res => {
        if (res.err === 0) {
          if (res.dat.isRRY==1) {
            this.vendorFlag = true
          }else{
            this.vendorFlag = false
          }
        }else{
          this.vendorFlag = false
        }
      })
    },
    // 避免表头出现各类符号字符无法识别
    getSlotData(scope,item){
      return scope.row[item]
    },
    // 动态获取宽度
    // calcWidth(row) {
    //   let flexWidth = 0;
    //   for (const char of row) {
    //     if ((char >= "A" && char <= "Z") || (char >= "a" && char <= "z")) {
    //       // 如果是英文字符，为字符分配8个单位宽度
    //       flexWidth += 8;
    //     } else if (char >= "\u4e00" && char <= "\u9fa5") {
    //       // 如果是中文字符，为字符分配20个单位宽度
    //       flexWidth += 20;
    //     } else {
    //       // 其他种类字符，为字符分配5个单位宽度
    //       flexWidth += 5;
    //     }
    //   }
    //   if (flexWidth < 50) {
    //     // 设置最小宽度
    //     flexWidth = 200;
    //   }
    //   if (flexWidth > 250) {
    //     // 设置最大宽度
    //     flexWidth = 250;
    //   }
    //   return flexWidth + "px";
    // },
    //定时刷新数据
    loopQuery () {
      this.timerEnergy = setInterval(() => {
        this.queryData();
      }, 300000);
    },
    // 图表高亮
    cellMouseEnterFun (row, column, cell, event) {
      this.curColIndex = column.columnKey + '';
    },
    // 拖动表头改变了列的宽度
    // cellDragendWidth(newWidth, oldWidth, column, event){
    //   console.log(newWidth, oldWidth, column, event,"11111111")
    //   // this.curColIndex = column.columnKey+'';
    //   document.querySelector('.lightCol').style.width = newWidth+'px'
    // },
    // =================
    // guanlian (field) {
    //   console.log(field,'deeeeeeeeee');
    //   console.log(this.allFieldNameBox,'this.allFieldNameBox');
    //   this.allFieldNameBox.forEach(item => {
    //     if (item.name == field.name) {
    //       item.flag = !field.flag
    //     }
    //   })
    // },
    //保存
    submitSave () {
      if (this.vendorFlag) {
        let arr=[]
        this.allFieldNameBoxGroup.forEach(item => {
          if (item.data.length>0) {
            item.data.forEach(i => {
              arr.push(i)
            })
          }
        })
        this.$nextTick(() => {
          this.setFields(arr)
        })
      }else{
        this.setFields(this.allFieldNameBox)
      }
    },
    // handleCheckAll1 () {
    //   let params = {
    //     sn: this.deviceInfo.sn,
    //     pn: this.deviceInfo.pn,
    //     devcode: this.deviceInfo.devcode,
    //     devaddr: this.deviceInfo.devaddr,
    //   }
    //   this.$request.get("selectDeviceFields", params).then(res => {
    //   })
    // },
    //恢复全选
    handleCheckAll2 () {
            // this.handleCheckAll1(),
      // this.controlDeviceVisible1 = false
      // this.queryData()
      // // this.getAllFieldName()
      if (this.vendorFlag) {
        // 分组视图：勾选全部字段，并同步各分组全选状态
        this.allFieldNameBoxGroup.forEach((item, index) => {
          item.data.forEach(subItem => {
            subItem.flag = true
          })
          item.checkAll = item.data.length > 0
          item.indeterminate = false
          this.$set(this.allFieldNameBoxGroup, index, { ...item })
        })
      } else {
        // 平铺视图：勾选全部字段
        this.allFieldNameBox.forEach(item => {
          item.flag = true
        })
      }
    },
    // handleCheckAll (val) {
    //   this.checkAll = val
    //   if (val) {
    //     this.allFieldNameBox.forEach(item => {
    //       this.allFieldNameBox1.push(item.name)
    //     })
    //     this.tableDataFields1 = this.allFieldNameBox1;
    //   } else {
    //     this.tableDataFields1 = [];
    //   }
    // },
    // handleCheck (value) {
    //   this.checkAll = this.tableDataFields1.length == this.allFieldNameBox.length ? true : false;
    // },
    //字段控制开关
    fieldSwiat () {
      this.controlDeviceVisible1 = true
      // this.getAllFieldName()
      this.getAllFieldList()
    },
    getAllFieldList(){
      (async () => {
        let p = {
          devaddr: this.deviceInfo.devaddr,
          devcode: this.deviceInfo.devcode,
          pn: this.deviceInfo.pn,
          sn: this.deviceInfo.sn
        };
        let res = await this.$request.getDEVMicroservices(
          "/hmi/api/auth/valueClouds/web/getUserDivTitle",
          p
        );
        let p2 = {
          page: this.pagination.currentPage,
          pageSize: this.pagination.pagesize,
          devaddr: this.deviceInfo.devaddr,
          devcode: this.deviceInfo.devcode,
          pn: this.deviceInfo.pn,
          sn: this.deviceInfo.sn,
          date: this.$filter.formatDate(this.selectedDate, "yyyy-MM-dd")
        };
        // deviceDats与表头接口结果无依赖，无论其成败都请求一次，title用于弹窗字段列表
        const result = await this.$request.getDEVMicroservices(
          "/drt/api/auth/web/deviceDats",
          p2
        );
        if (res.code == 0) {
          if (result.code === 0 && Array.isArray(result.data.title)) {
            // 用户尚未保存过表头时，先用deviceDats返回的title初始化再重查表头接口
            if (res.data.length === 0) {
              await this.firstAddTitle(result.data.title);
              const res2 = await this.$request.getDEVMicroservices(
                "/hmi/api/auth/valueClouds/web/getUserDivTitle",
                p
              );
              if (res2.code == 0) {
                res = res2;
              }
            }
            // 用deviceDats的title+用户保存的display合并出字段列表(按索引对应，过滤掉下标0、1两列 id和时间戳，不参与分组显隐勾选)，再走分组渲染
            if (Array.isArray(res.data)) {
              const list = result.data.title.map((item, index) => {
                const dataItem = res.data[index];
                return {
                  ...item,
                  name: item.title,
                  id:dataItem.optional,
                  flag: typeof dataItem !== "object" ? true : dataItem.display,
                  titleIndex:typeof dataItem !== "object" ? index : dataItem.titleIndex
                };
              }).filter((item, index) => index > 1);
              // filter(item => item.name !== "id");
              console.log(list)
              this.groupFieldList(list);
            }
          } else {
            this.allFieldNameBox = [];
          }
        } else {
          this.$message.error(res.message || res.errorMessage);
        }
      })();
    },
    // 初始化用户表头(未保存过表头时调用)
    firstAddTitle (list) {
      let fisrtParam = {
        devaddr: this.deviceInfo.devaddr,
        devcode: this.deviceInfo.devcode,
        pn: this.deviceInfo.pn,
        sn: this.deviceInfo.sn,
        list: list //表头
      };
      return this.$request.postDEVMicroservices(
        "/hmi/api/auth/valueClouds/web/FirstAddTitle",
        fisrtParam
      );
    },
    // 切换上一天
    toPreDay () {
      let aimTime = this.$filter.formatDate(this.$refs.dateDay.value, "yyyy-MM-dd");
      let preDay = this.$tool.getYestoday(aimTime);
      // this.selectedDate = preDay;
      if (/^\d{4}-\d{2}-\d{2}$/.test(preDay)) {
        const [y, m, d] = preDay.split('-');
        this.selectedDate = new Date(Number(y), Number(m) - 1, Number(d));
      } else {
        this.selectedDate = preDay;
      }
    },
    // 切换下一天
    toNextDay () {
      let dayValue= new Date(this.$refs.dateDay.value)
      if (dayValue>Date.now()-8.64e7) return this.$message.warning(this.$t("device.noDate"));
      let aimTime = this.$filter.formatDate(this.$refs.dateDay.value, "yyyy-MM-dd");
      let nextDay = this.$tool.getNextday(aimTime);
      // this.selectedDate = nextDay;
      if (/^\d{4}-\d{2}-\d{2}$/.test(nextDay)) {
        const [y, m, d] = nextDay.split('-');
        this.selectedDate = new Date(Number(y), Number(m) - 1, Number(d));
      } else {
        this.selectedDate = nextDay;
      }
    },
    // 查询表格数据
    queryData (reset) {
      if (reset) this.pagination.currentPage = 1;
      this.isLoading = true;
      (async () => {
        // 先查用户保存的表头，display用于过滤表格展示字段
        let p = {
          devaddr: this.deviceInfo.devaddr,
          devcode: this.deviceInfo.devcode,
          pn: this.deviceInfo.pn,
          sn: this.deviceInfo.sn
        };
        let res = await this.$request.getDEVMicroservices(
          "/hmi/api/auth/valueClouds/web/getUserDivTitle",
          p
        ).catch(() => null);
        let param = {
          page: this.pagination.currentPage,
          pageSize: this.pagination.pagesize,
          i18n: this.$lang.currentLang,
          pn: this.deviceInfo.pn,
          devcode: this.deviceInfo.devcode,
          devaddr: this.deviceInfo.devaddr,
          sn: this.deviceInfo.sn,
          date: this.$filter.formatDate(this.selectedDate, "yyyy-MM-dd")
        };
        // deviceDats与表头接口结果无依赖，无论其成败都请求一次
        const result = await this.$request.getDEVMicroservices("/drt/api/auth/web/deviceDats", param).catch(() => null);
        if (res && res.code == 0) {
          if (result && result.code === 0 && Array.isArray(result.data.title)) {
            // 用户尚未保存过表头时，先用deviceDats返回的title初始化再重查表头接口
            if (Array.isArray(res.data) && res.data.length === 0) {
              await this.firstAddTitle(result.data.title);
              const res2 = await this.$request.getDEVMicroservices(
                "/hmi/api/auth/valueClouds/web/getUserDivTitle",
                p
              ).catch(() => null);
              if (res2 && res2.code == 0) {
                res = res2;
              }
            }
          }
        } else if (res) {
          // 表头接口失败不影响表格渲染(按全部字段展示)
          this.$message.error(res.message || res.errorMessage);
        }
        // 各列显隐状态(按索引与title对应)，无保存数据时默认全展示
        const displayList = res && Array.isArray(res.data) ? res.data : null;
          if (result && result.code === 0) {
            this.pagination.total = result.data.total
            let tableData = [],
              //  tableDataNoId=[],
              tableDataFields = [],
              // tableDataFields1 = [],
              title = result.data.title,
              row = result.data.row
            row.forEach((item, rowIndex) => {
              console.log(item, 'item')
              let clause = {};
              // clauseNoId = {}
              item.field.forEach((val, index) => {  
                // 增
                if (val == 'undefined' || val == 'null') { val = '--' }
                // 用户设置不展示的字段直接跳过(display按索引与title对应)
                const dataItem = displayList ? displayList[index] : null;
                if (dataItem && typeof dataItem === "object" && !dataItem.display) return;
                let field = title[index].title
                // !rowIndex && field !== "id" && tableDataFields1.push(field)
                if (title[index].unit) {
                  field += `(${title[index].unit})`
                }
                !rowIndex && field !== "id" && tableDataFields.push(field)
                clause[field] = val;
              });
              tableData.push(clause)
            })
            this.tableData = tableData
            this.tableDataFields = tableDataFields
            // 有数据才展示刷新/字段控制，空数据不展示
            this.currentData = tableData.length > 0;
            // 保存表头数据(含id列，display按索引与title对应，供导出报表使用)
            this.webHeads = title.map((item, index) => {
              const dataItem = displayList ? displayList[index] : null;
              return {
                // id为内部列，导出时不展示
                display: item.title === "id" ? false : (typeof dataItem !== "object" ? true : dataItem.display),
                index: typeof dataItem !== "object" ? index : dataItem.titleIndex,
                title: item.title
              };
            })
            console.log(this.webHeads,"this.webHeads")
            // this.tableDataFields1 = tableDataFields1
            if(this.needDoLayout){
               this.$nextTick(() => {
            　　　　this.$refs['tableRef'].doLayout();
          　　　});
　　　　    　　　this.needDoLayout = false; 
            } 
          } else {
            this.emptyText = true;
            this.pagination.total = 0
            this.tableData = []
            this.tableDataFields = []
            this.currentData = false
          }
          this.isLoading = false
      })().catch(() => {
        this.isLoading = false
      })
    },
    // //查询数据表格所有字段
    // getAllFieldName () {
    //   this.allFieldNameBox = []
    //   let param = {
    //     lang: this.$lang.currentLang,
    //     pn: this.deviceInfo.pn,
    //     devcode: this.deviceInfo.devcode,
    //     devaddr: this.deviceInfo.devaddr,
    //     sn: this.deviceInfo.sn,
    //   }
    //   this.$request.getDEVMicroservices("/drt/api/auth/web/deviceFields", param).then(res => {
    //     if (res.code === 0) {
    //       this.groupFieldList(res.data)
    //     } else {
    //       this.allFieldNameBox = []
    //       this.allFieldNameBoxGroup = []
    //     }
    //   }).catch(err => {
    //     console.error('获取字段失败:', err)
    //     this.allFieldNameBox = []
    //     this.allFieldNameBoxGroup = []
    //   })
    // },
    // 字段列表分组渲染(纯数据处理，不请求接口)
    groupFieldList (data) {
      this.allFieldNameBox = data
      // 定义分组key顺序
      let groupKeys = ['pv','gd','bt','bc','sy','eg','hl','bse','bse','bse','std','svs','pvs','grd','bat','bat1','bat2','cts','los','bas','adv','else'];
      // 用对象收集各分组
      const tempGroupsObj = {};
      groupKeys.forEach(key => tempGroupsObj[key] = []);
      data.forEach(item => {
        var s = item.id;
        // if (!s) {
        //   // console.warn('字段 ID 为空:', item)
        //   return  // 跳过无效数据
        // }
        // id为空时归入其他设置分组，避免startsWith报错
        if (!s) {
          tempGroupsObj['else'].push(item);
        } else if (s.startsWith("pv_")) {
          tempGroupsObj['pv'].push(item);
        } else if (s.startsWith("gd_")) {
          tempGroupsObj['gd'].push(item);
        } else if (s.startsWith("bt_")) {
          tempGroupsObj['bt'].push(item);
        } else if (s.startsWith("bc_")) {
          tempGroupsObj['bc'].push(item);
        } else if (s.startsWith("sy_")) {
          tempGroupsObj['sy'].push(item);
        } else if (s.startsWith("eg_")) {
          tempGroupsObj['eg'].push(item);
        } else if (s.startsWith("hl_")) {
          tempGroupsObj['hl'].push(item);
        } else if (s.startsWith("bse_")) {
          tempGroupsObj['std'].push(item);
        } else if (s.startsWith("std_")) {
          tempGroupsObj['std'].push(item);
        } else if (s.startsWith("sys_")) {
          tempGroupsObj['svs'].push(item);
        } else if (s.startsWith("pvs_")) {
          tempGroupsObj['pvs'].push(item);
        } else if (s.startsWith("grd_")) {
          tempGroupsObj['grd'].push(item);
        } else if (s.startsWith("bat_")) {
          tempGroupsObj['bat'].push(item);
        } else if (s.startsWith("bat1_")) {
          tempGroupsObj['bat1'].push(item);
        } else if (s.startsWith("bat2_")) {
          tempGroupsObj['bat2'].push(item);
        } else if (s.startsWith("cts_")) {
          tempGroupsObj['cts'].push(item);
        } else if (s.startsWith("los_")) {
          tempGroupsObj['los'].push(item);
        } else if (s.startsWith("bas_")) {
          tempGroupsObj['bas'].push(item);
        } else if (s.startsWith("adv_")) {
          tempGroupsObj['adv'].push(item);
        } else {
          tempGroupsObj['else'].push(item);
        }
      })
      console.log(tempGroupsObj,'tempGroupsObj##');
      
      // 按当前allFieldNameBoxGroup顺序，重新排序为groupKeys顺序
      this.allFieldNameBoxGroup = groupKeys.map(key => {
        let group = this.allFieldNameBoxGroup.find(g => g.key === key);
        if (!group) {
          group = { key, title: '', data: [], checkAll: false, indeterminate: false};
        }
        return { ...group, data: tempGroupsObj[key], checkAll: false, indeterminate: false };
      });
      // ✅ 初始化全选状态
      this.$nextTick(() => {
        this.allFieldNameBoxGroup.forEach((item, index) => {
          if (item.data.length > 0) {
            const allChecked = item.data.every(i => i.flag)
            const someChecked = item.data.some(i => i.flag)
            
            item.checkAll = allChecked
            item.indeterminate = someChecked && !allChecked
            
            this.$set(this.allFieldNameBoxGroup, index, { ...item })
          }
        })
      })
      console.log(this.allFieldNameBoxGroup,'this.allFieldNameBoxGroup');
    },
    handleCheckAllChange(index, item) {
      console.log('全选点击', index, item.checkAll)
      
      const isChecked = item.checkAll  // ✅ 获取当前全选框状态
      
      // ✅ 更新所有子项的 flag
      item.data.forEach(subItem => {
        subItem.flag = isChecked
      })
      
      // ✅ 更新半选状态
      item.indeterminate = false
      
      // ✅ 确保响应式更新
      this.$set(this.allFieldNameBoxGroup, index, { ...item })
    },
    // ✅ 子项变化时更新全选状态
    handleSubItemChange(groupIndex, group) {
      const allChecked = group.data.every(i => i.flag)
      const someChecked = group.data.some(i => i.flag)
      
      group.checkAll = allChecked
      group.indeterminate = someChecked && !allChecked
      
      this.$set(this.allFieldNameBoxGroup, groupIndex, { ...group })
    },
    //勾选时触发的事件
    setFields (field) {
      if (field) {
        console.log(field)
        // 按接口userTitleDTOList结构映射：display<-flag、titleIndex<-titleIndex、optional<-id
        let userTitleDTOList = field.map(item => {
          return {
            display: item.flag,
            titleIndex: item.titleIndex,
            // optional: item.id
          };
        });
        let fisrtParam = {
          devaddr: this.deviceInfo.devaddr,
          devcode: this.deviceInfo.devcode,
          pn: this.deviceInfo.pn,
          sn: this.deviceInfo.sn,
          userTitleDTOList: userTitleDTOList //表头
        };
        this.$request.postDEVMicroservices(
          "/hmi/api/auth/valueClouds/web/userSaveOrUpdateTitle",
          fisrtParam
        ).then(res => {
          if (res.code === 0) {
            // 保存成功后再刷新表格并关闭弹窗
            this.queryData()
            this.controlDeviceVisible1 = false
          } else {
            this.$message.error(res.message || res.errorMessage);
          }
        }).catch(() => {
          this.$message.error(this.$t('errCode.3'));
        });
        // var names1 = []
        // var visable1 = []
        // var position1 = []
        // field.forEach(item => {
        //   names1.push(item.name)
        //   visable1.push(item.flag)
        //   position1.push(item.pos)
        // })
        // let param = {
        //   i18n: this.$lang.currentLang,
        //   pn: this.deviceInfo.pn,
        //   devcode: this.deviceInfo.devcode,
        //   devaddr: this.deviceInfo.devaddr,
        //   sn: this.deviceInfo.sn,
        //   names: names1,
        //   visables: visable1,
        //   position: position1.join(','),
        //   // position:position1[0],
        // }
        // this.$request.post('editDeviceFieldsEssPost', param).then(res => {
        //   if (res.err === 0) {
        //     this.getAllFieldName()
        //   }
        // })

      }

    },
    // 采集频率升级页面
    goCollectionUp(isInit = false){
      if (!isInit) this.collectFastButton = true;
      this.$request.getMicroserDess(`/css/api/auth/web/collectorForDIS/${this.deviceInfo.pn}`).then(res => {
        if (!isInit) this.collectFastButton = false;
        if (res.code === 0) {
          this.datFetch = res.data.datFetch;
          // 初始调用时只获取数据，不执行后续逻辑
          if (isInit) return;
          if (!res.data.transmissionMode) {
            this.$message.error(this.$t('collectionFrequencyUP.noRecharg'));
            return;
          }
          let mode = res.data.transmissionMode.toLowerCase();
          let gprsType = '4G';
          if (mode.includes('wi') || mode.includes('wf')) {
            gprsType = 'WIFI';
          } else if (mode.includes('gprs')) {
            // gprsType = '2G';
            this.$message.error(this.$t('collectionFrequencyUP.noRecharg'));
            return;
          }else{
            this.$message.error(this.$t('collectionFrequencyUP.noRecharg'));
            return;
          }
          this.gprsType = gprsType;
          // TODO: 根据 gprsType 执行后续逻辑
          this.$store.commit('saveIsShow', 9);
          this.$store.state.event.foldGeneralSidebarNew = true;
          this.$emit('collectionUPEvent', {
            collectionUPType: 2,
            gprsType: gprsType,
            rechargeFlagObj: this.rechargeFlagObj
          });
        }else{
          // 初始调用时不提示，只有点击时才提示
          if (!isInit) {
            this.$message.error(this.$t('collectionFrequencyUP.noRecharg'));
          }
        }
      }).catch(() => {
        this.collectFastButton = false;
      });
    },
    exportDeviceDetail () {
      if (!this.deviceInfo.pn) return false;
      this.exportDeviceParams = {
        pn: this.deviceInfo.pn,
        devcode: this.deviceInfo.devcode,
        devaddr: this.deviceInfo.devaddr,
        sn: this.deviceInfo.sn,
        webHeads: this.webHeads
        };
      // let param = {
      //   action: "exportDeviceDataDetail",
      //   page: this.pagination.currentPage - 1,
      //   pagesize: this.pagination.pagesize,
      //   i18n: this.$lang.currentLang,
      //   pn: this.deviceInfo.pn,
      //   devcode: this.deviceInfo.devcode,
      //   devaddr: this.deviceInfo.devaddr,
      //   sn: this.deviceInfo.sn,
      //   date: this.$filter.formatDate(this.selectedDate, "yyyy-MM-dd")
      // };
      // this.$request.get("exportDeviceDataDetail", param)
      //   .then((res) => {
      //     // 演示账号
      //     if (res.err) {
      //       this.$message.error(this.$t(`errCode.${res.err}`));
      //       return;
      //     } else {
      //       window.location.href = this.$request.http_download_url_new(param)
      //     }
      //     this.$message.success(this.$t("report.download"));
      //   }).then(() => {
      //     // this.$message.success(this.$t("report.download"));
      //   }).catch((err) => {
      //     this.$message.error(err);
      //   });
    }
  },
}
</script>
<style lang="less" scoped>
.deviceClauseNew {
  display: flex;
  flex-direction: column;
  background-color: #202D35;

  .section-header {
    // padding: 20px 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #7B8395;
    position: relative;

    .exportClass {
      display: flex;
      flex-direction: row;
      height: 100%;

      // 筛选
      .el-dropdown {
        color: #00FEBB;
        padding: 0 15px;
        line-height: 46px;
      }

      .FieldControl {
        position: relative;
        width: 46px;
        color: @primaryTextColor;
        padding: 0 15px;
        line-height: 46px;
        cursor: pointer;

        .ziduan {
          background-image: url(../../../../assets/img/general/Union.png);
          height: 14px;
          width: 14px;
        }

        .shuaxin {
          background-image: url(../../../../assets/img/general/Vector.png);
          height: 16px;
          width: 16px;
        }
      }

      // 搜索
      // .button-search {
      //   background: transparent;
      //   border: none;
      //   padding: 0px;
      //   color: #00FEBB;
      // }

      .button {
        height: 48px;
        line-height: 48px;
        padding: 0 25px;
        margin-top: 0px;
        color: @primaryTextColor;
        background: transparent;
        border: none;
      }

      .search-alert {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 48px;
        z-index: 1;
        background: rgb(34, 45, 53);
        display: flex;
        align-items: center;
        justify-content: space-between;

        .search-hide {
          display: inline-block;
          // position: absolute;
          // right: -58px;
          line-height: 47px;
          padding: 0 15px;
          font-size: 14px;
          background: #202D35;
          color: #7B8395;
          border-left: 1px solid #7B8395;
          cursor: pointer;
        }

        /deep/.el-input {
          flex: 1;
        }

        /deep/.el-input .el-input__clear,
        /deep/.el-input .el-input__clear:hover {
          color: #7B8395;
        }

        /deep/.el-input .el-input__inner,
        /deep/.el-input .el-input__inner:hover {
          height: 47px;
          border-radius: 0px;
          border: none;
          background: #202D35;
          color: #ffffff;
          padding-left: 40px;
        }

        /deep/.el-input__prefix {
          left: 0px;
        }

        /deep/.el-input__icon {
          width: 40px;
        }

        /deep/.el-input__suffix {
          right: 0px;
        }

        /deep/.el-icon-circle-close:before {
          content: 'X'
        }
      }
      .collectFast{
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 8px 0;
        width:fit-content;
        background: #22413b;
        padding: 2px 5px;
        border: 1px solid #30EC70;
        color: #30EC70;
        border-radius: 6px;
        margin-right: 15px;
      }
      .collectFast-text {
        display: inline-block;
        max-width: 174px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        line-height: 1.5;
        height: 24px; 
        vertical-align: middle;
      }
      .collectFast .iconfont {
        font-size: 18px; 
        // margin-left: 6px;
        vertical-align: middle;
        line-height: 1;
      }
      .collectFastButtonElse{
          background-size: cover !important; /* 图片大小填充整个容器 */
          background-position: center !important; /* 背景图居中 */
          background-repeat: no-repeat !important;
          background: url("../../../../assets/img/accelerating.gif");
      }

      .button-export {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0px 16px;
        // margin-right: 20px;
        // border-radius: 4px;
        // background: var(--theme-color);
        background: @primaryTextColor;
        color: rgb(34, 45, 53);
        font-size: 14px;
        cursor: pointer;

        .ico-download {
          width: 16px;
          height: 16px;
          background: url(../../../../assets/img/general/Icon_Download.png) no-repeat;
          background-size: 100%;
          background-position: center;
          margin-left: 10px;
        }
      }
    }

    // 时间
    // /deep/.el-date-editor.el-input {
    //   width: 150px;
    // }
    /deep/.el-date-editor.el-input .el-input__prefix {
      right: auto;
      left: 10px;
      font-size: 16px;
      color: #00FEBB;
    }

    /deep/.el-date-editor.el-input .el-input__inner {
      height: 46px;
      padding-left: 52px;
      background: transparent;
      color: #ffffff;
      border: none;
      border-radius: 0px;
      // border-left: 1px solid #7B8395;
      // border-right: 1px solid #7B8395;
    }

    /deep/.el-date-editor.el-input .el-input__suffix .el-input__icon:after {
      content: "";
      display: inline-block;
      position: absolute;
      top: 12px;
      right: -2px;
      height: 20px;
      width: 20px;
      background: url(../../../../assets/img/general/Icon_Down_Border.png) no-repeat;
      background-size: 100%;
      background-position: center;
    }

    // 时间图标
    /deep/.el-icon-date:before {
      content: "";
      display: inline-block;
      position: absolute;
      top: 12px;
      left: 0px;
      height: 24px;
      width: 24px;
      background: url(../../../../assets/img/general/Icon_Calendar.png) no-repeat;
      background-size: 100%;
      background-position: center;
    }

    // 日期盒子
    .datePreNext {
      padding: 0px 16px;
      // border-left: 1px solid #7B8395;
      border-right: 1px solid #7B8395;

      /deep/.datepicker {
        margin: 0px;
        // margin-right: 16px;
      }

      /deep/.el-date-editor {
        margin-right: 16px;
      }

      /deep/.el-date-editor.el-input {
        width: 150px;
      }

      /deep/.el-date-editor.el-input .el-input__inner {
        padding: 0px;
        text-align: center;
      }

      //.el-input__prefix,
      //.el-input__suffix
      /deep/.el-input__prefix {
        display: none;
      }

      /deep/.el-input__suffix {
        top: 2px;
        right: 16px;
      }

      .date-icon {
        display: inline-block;
        width: 24px;
        height: 24px;
        background: url(../../../../assets/img/general/Icon_Calendar.png);
        background-size: 100%;
        background-position: center;
        background-repeat: no-repeat;
        vertical-align: middle;
        margin-right: 16px;
      }

      .date-pre {
        background: url(../../../../assets/img/general/Chart_Date_Pre.png);
      }

      .date-next {
        background: url(../../../../assets/img/general/Chart_Date_Next.png);
      }

      .date-btn {
        color: #ffffff;
        cursor: pointer;
        display: inline-block;
        height: 16px;
        width: 16px;
        background-size: 100%;
        background-position: center;
        background-repeat: no-repeat;
        vertical-align: middle;
      }
    }
  }

  // 表格
  .section-content {
    flex: 1;
    overflow: auto;

    /deep/.el-icon-loading {
      font-size: 28px;
    }

    /deep/.el-table__body tr,
    /deep/.el-table__body td {
      background-color: #202D35;
      color: #ffffff;
      border-bottom: 1px solid #7B8395;
    }

    /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
      background-color: #202D35;
      color: #ffffff;
    }

    /deep/.el-table--striped .el-table__body tr.el-table__row--striped.current-row td,
    /deep/.el-table__body tr.current-row>td,
    /deep/.el-table__body tr.hover-row.current-row>td,
    /deep/.el-table__body tr.hover-row.el-table__row--striped.current-row>td,
    /deep/.el-table__body tr.hover-row.el-table__row--striped>td,
    /deep/.el-table__body tr.hover-row td {
      background-color: rgba(48, 208, 150, 0.15);
    }

    /deep/ .el-table__body tr.hover-row {
      border: 1px solid #00FEBB;
    }

    /deep/ .el-table--border {
      border: none
    }

    /deep/.el-table--border td,
    /deep/.el-table--border th,
    /deep/.el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
      border-right: 1px solid #7B8395;
    }

    /deep/.el-table td,
    /deep/.el-table th.is-leaf {
      border: none;
      border-right: 1px solid #7B8395;
      border-bottom: 1px solid #7B8395;
    }

    /deep/.el-table,
    .el-table__expanded-cell {
      background-color: transparent;
    }

    /deep/.el-table__fixed-right::before,
    /deep/.el-table__fixed::before {
      display: none;
    }

    // =====================
    // 横纵向着色
    .lightCol {
      background: rgba(48, 208, 150, 0.15) !important;
      // width: 180px;
      width: 100%;
      height: 44px;
      line-height: 42px;
      // border: 1px solid @primaryTextColor;
    }

    // =====================

    // 滚动条
    /deep/::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: #222d35;
    }

    /deep/::-webkit-scrollbar-thumb {
      background: #B4B8C1;
      border-radius: 3px;
    }

    .tablemain {
      /deep/ .cell {
        padding: 0px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .tableloding {

      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, .5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    // 关于头部右侧空白
    /deep/.el-table__fixed-right-patch {
      background-color: rgb(65, 80, 90);
      border-bottom: none;
    }

    /deep/th.gutter {
      background-color: rgb(65, 80, 90);
    }
  }

  // 分页
  .tablebottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid rgba(198, 209, 221, 0.5);

    // 分页
    .pagination {
      line-height: 48px;
      height: 48px;
      padding: 0;
      margin: 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-right: 16px;

      /deep/.el-pager li {
        vertical-align: middle;
      }

      /deep/.el-select .el-input {
        width: 90px;
        margin: 0px;
      }

      /deep/.el-input .el-input__inner {
        background-color: #202D35;
        color: #ffffff;
      }

      /deep/.el-input__suffix {
        right: 10px;
      }

      /deep/.el-pagination__sizes {
        margin: 0px;
        height: 48px;
        line-height: 48px;
      }

      /deep/.el-pagination__total {
        color: #fff;
        padding-left: 15px;
        border-left: 1px solid #7B8395;
        height: 48px;
        line-height: 48px;
      }

      /deep/.el-pager li:not(.disabled).active {
        // background: #15C491;
        // color: #ffffff;
        background-color: #2B3842;
        color: #15C491;
      }

      // li:not(.disabled):not(.active):hover
      /deep/.el-pager li:not(.disabled):hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pager li {
        background-color: #2B3842;
        color: #7B8395;
      }

      // 页条数下拉
      /deep/.el-select .el-input .el-input__inner {
        border: none;
        height: 48px;
        line-height: 48px;
        border-radius: 0px;
      }

      /deep/.el-select .el-input .el-input__inner:hover {
        background: @primaryColorTransparency30;
      }

      // 跳页
      /deep/.el-pagination__jump {
        color: #ffffff;
      }

      /deep/.el-pagination__editor {
        padding: 0px 6px;
      }

      /deep/.el-pagination__editor.el-input .el-input__inner {
        border: 1px solid #7B8395;
      }
    }

    // 分页前后按钮
    /deep/.el-pagination.is-background .btn-next,
    /deep/.el-pagination.is-background .btn-prev {
      background-color: #2B3842;
      color: #7B8395;
    }

    /deep/.el-pagination.is-background .btn-next:hover,
    /deep/.el-pagination.is-background .btn-prev:hover {
      background-color: @primaryColorTransparency30;
      color: rgba(255, 255, 255, 1);
    }

    /deep/.el-pagination.is-background button[disabled],
    /deep/.el-pagination.is-background button[disabled]:hover {
      background-color: #2B3842;
      color: #7B8395;
    }

    /deep/.el-checkbox .el-checkbox__input.is-checked+.el-checkbox__label {
      color: #fff;
    }
  }

  .dialogModalNew {
    .dialog-content {
      .control {
        // .el-checkbox-group {
          .el-checkbox {

            width: 200px;
            margin-right: 0px;
            padding: 12px 0 12px;
            .name {
              width: 170px;
              height: 20px;
              line-height: 20px;
              display: block;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              box-sizing: border-box;
              padding-top: 4px;
            }
          }
        // }
      }

      /deep/.dialog-footer {
        border-top: 0px !important;
      }

      /deep/.footBotton .button1 {
        border: #16D09A 1px solid !important;
        color: #16D09A !important;
        background-color: transparent !important;

        &:hover {
          background: #16D09A !important;
          color: #222D35 !important;
        }
      }
    }
  }

  /deep/.el-checkbox__label {
    font-size: 13px;
    line-height: 16px;

  }

  /deep/.el-checkbox__input .el-checkbox__inner {
    width: 16px;
    height: 16px;
  }

  /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: @primaryTextColor;
  }

  /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
    top: 2px;
    left: 6px;
  }

  /deep/.el-checkbox .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #fff;
  }
  /deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: @primaryTextColor; // 修改为你想要的半选状态颜色
    border-color: #1890ff;
  }
}

.section {
  border: none;
  box-shadow: none;
  padding: 0;
}
/deep/ .el-collapse{
  border: none;
}
/deep/ .el-collapse-item__wrap{
  border: none;
  background-color: transparent;
}
/deep/ .el-collapse-item__header{
  border: none;
  background-color: transparent;
  height: 48px;
  line-height: 48px;
  font-size: 16px;
  color: #fff;
}
/deep/ .el-collapse-item__content{
  background-color: transparent;
  padding: 0;
}
</style>
<style lang="less">
// #分页下拉框#
.select-page {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 12px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
    background-color: rgb(34, 45, 53);
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
    min-width: 110px;
  }

  .el-select-dropdown__item.hover {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 16px;
  }

  &[x-placement^=top] .popper__arrow {
    display: none;
  }
}

.deviceClause {

  .el-popper .popper__arrow,
  .el-popper .popper__arrow::after {
    display: none;
  }
}

// 筛选下拉框
.clause-dropdown {
  min-width: 200px;

  &.el-dropdown-menu {
    background: #202D35;
    color: #ffffff;
    border: none;
  }

  &.el-dropdown-menu .el-dropdown-menu__item {
    color: #ffffff;
  }

  &.el-dropdown-menu .el-dropdown-menu__item:hover,
  &.el-dropdown-menu .el-dropdown-menu__item:focus {
    background: #202D35;
    color: #ffffff;
  }

  &.el-dropdown-menu .el-dropdown-menu__item:not(:last-child) {
    border: none;
  }

  .topLine {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .allFiledNameClass {
    width: 462px;
    column-count: 2;
    height: 400px;
    max-height: 500px;

    .el-dropdown-menu__item {
      width: 200px;
    }
  }
}
</style>